import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Link } from '@comparethemarketau/manor-link';
import { Typography } from '@comparethemarketau/manor-typography';

import { faFileAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { withQuoteFlatten } from './with_quote_flatten';
import { getBreakpointFromManor } from 'ctm-components';

const useStyles = createUseStyles((theme) => ({
    text: {
        fontWeight: theme.fontWeight.semibold,
        fontSize: theme.fontSize.sm,
        lineHeight: theme.lineHeight.tight
    },
    icon: {
        marginLeft: '0.5rem'
    },
    defaultButton: {
        display: 'flex',
        alignItems: 'center',
        margin: '1rem'
    }
}));

const _ProductDocuments = ({ productDisclosures, productId, children, className }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    let pdsLink = "Product Disclosure Statement";
    const pdsObject = productDisclosures && productDisclosures.find((element) => {
        const code = element.get('code');
        return ['pds', 'pdsa'].includes(code && code.toLowerCase());
    });
    const url = pdsObject && pdsObject.get('url');

    const breakpoint = getBreakpointFromManor();

    if (breakpoint === 'xs' || breakpoint === 'sm') {
        pdsLink = "PDS";
    }

    return (
        <div className={classNames(className)}>
            <Link
                trackingLabel={`Policy Documents for productId: ${productId}`}
                underline="none"
                href={url}
                target="_blank"
            >
                {children
                    || (
                        <div className={classes.defaultButton}>
                            <Typography display="inline"
                                className={classes.text}
                            >
                                {pdsLink}
                            </Typography>
                            <FontAwesomeIcon icon={faFileAlt} className={classes.icon} />
                        </div>
                    )}
            </Link>
        </div>
    );
};

_ProductDocuments.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,

    quote: PropTypes.object,
    productId: PropTypes.string,
    productDisclosures: PropTypes.object
};

const ProductDocuments = withQuoteFlatten(_ProductDocuments);

export { ProductDocuments };
